export const formatSoftBreaks = content =>
  content.replace(
    /<br\s*\/?>(?:\r?\n)?/g,
    '<span class="block h-1" aria-hidden="true"></span>'
  );
